export const HEADERS_MARKDOWN_TYPE = 'wix-draft-plugin-headers-markdown';
